export function getTranslation(lang: string): {
    applyNow: string;
    aprAndTerm: string;
    ifBorrowLess: string;
    ifBorrowMore: string;
    loanAmount: string;
    monthlyPayment: string;
    months: string;
    yourMonthlyPayment: string;
} {
    const translationStrings = {
        en: {
            applyNow: 'Apply Now',
            aprAndTerm: 'APR and term (in months)',
            ifBorrowLess: 'If you borrow less',
            ifBorrowMore: 'If you borrow more',
            loanAmount: 'Loan amount',
            monthlyPayment: 'Monthly Payment',
            months: 'months',
            yourMonthlyPayment: 'Your monthly payment',
        },
        es: {
            applyNow: 'Aplique ahora',
            aprAndTerm: 'TAE y plazo (en meses)',
            ifBorrowLess: 'Si pide prestado menos',
            ifBorrowMore: 'Si pide prestado más',
            loanAmount: 'Monto del préstamo',
            monthlyPayment: 'Mensualidad',
            months: 'meses',
            yourMonthlyPayment: 'Su pago mensual',
        }
    }
    return translationStrings[lang];
}
